import { appStore } from "@app/store/store"

export const AdyenRequests = {
	url: undefined,
	key: undefined,
	relationToken: undefined,
	init: (settings, relationToken) => {
		AdyenRequests.url = settings.connectorUrl + "/"
		AdyenRequests.key = settings.connectorKey
		AdyenRequests.relationToken = relationToken
	},
	getOrder: webToken => createRequest("GET", "sales/order", { webToken }, undefined, undefined),
	getLinkInfo: reference =>
		createRequest("GET", "payment/history", { reference }, undefined, undefined).then(json => {
			if (json.json) {
				return json.json.reverse().find(e => e.type == "linkInfos")
			}
			return undefined
		}),
	getPaymentMethods: ({ webToken = undefined, allowedPaymentMethods, relationPaymentToken = undefined }) =>
		createRequest("GET", "Adyen/PaymentMethods", {
			webToken,
			relationPaymentToken,
			relationToken: AdyenRequests.relationToken,
		}).then(json => {
			if (json.paymentMethods && allowedPaymentMethods.length > 0) {
				json.paymentMethods = json.paymentMethods.filter(method => {
					if (allowedPaymentMethods.indexOf(method.type) > -1) {
						return true
					}
					if (method.type == "scheme") {
						method.brands = method.brands.filter(brand => allowedPaymentMethods.indexOf(brand) > -1)
						return method.brands.length > 0
					}

					return false
				})

				if (json.paymentMethods.length == 0) {
					throw new Error("no payment methods")
				}
			}
			return json
		}),
	pay: ({ webToken, riskData, paymentMethod, relationPaymentToken, storePaymentMethod, recurringProcessModel, isReccuringPayment, amount, paymentId }) =>
		createRequest("POST", "Adyen/Payment/Pay", undefined, {
			webToken,
			riskData,
			paymentMethod,
			relationPaymentToken,
			storePaymentMethod,
			recurringProcessModel,
			isReccuringPayment,
			amount,
			express: true,
			paymentId,
		}),
	updateOrder: ({ webToken, paymentData, amount, pspReference }) =>
		createRequest("POST", "Adyen/Payment/paypal/update", undefined, {
			webToken,
			amount: {
				value: amount,
			},
			paymentData,
			pspReference,
		}),
	getPaymentDetail: ({ webToken, data, relationPaymentToken }) => createRequest("POST", "Adyen/Payment/Details", { webToken, relationPaymentToken }, data),
	storeErrorTrace: ({ error, infos = undefined }) =>
		createRequest("POST", "error/trace", undefined, {
			uri: location.href,
			message: "BirdPay;" + (typeof error?.message == "object" ? JSON.stringify(error?.message) : error?.message),
			body: JSON.stringify({
				...(infos || {}),
				...splitUrl(window.location.href),
				userAgent: navigator.userAgent,
			}),
			db: false,
			stackTrace: error?.stack,
		}),
	deletePayment: ({ storedPaymentMethodId, paymentId = undefined }) =>
		createRequest("DELETE", "Adyen/Payment", {
			relationToken: AdyenRequests.relationToken,
			storedPaymentMethodId,
			paymentId,
		}),
}

const createRequest = (method, url, params, body, headers) => {
	let serializedParams = paramsSerializer(params)
	if (!method) throw new Error("missing request method")
	if (!url) throw new Error("missing request url")
	return new Promise((resolve, reject) => {
		fetch(AdyenRequests.url + url + "?" + serializedParams, {
			method: method,
			headers: {
				apiKey: AdyenRequests.key,
				"content-type": "application/json",
				Authorization: "Bearer " + appStore.get("core.accessToken"),
				...(headers || {}),
			},
			body: method == "POST" ? JSON.stringify(body || {}) : undefined,
		})
			.then(async e => {
				if (e.status != 200) {
					throw new Error("invalid status;" + e.status)
				}
				const json = await e.json()
				resolve(json)
			})
			.catch(e => {
				reject(e)
			})
	})
}

const paramsSerializer = params => {
	let delemiter = ""
	let paramString = ""
	for (let key of Object.keys(params || {})) {
		if (params[key] !== undefined && params[key] !== null) {
			paramString += delemiter + key + "=" + params[key]
			if (delemiter === "") {
				delemiter = "&"
			}
		}
	}
	return paramString
}

export const splitUrl = url => {
	const result = {
		url: "",
		params: {},
	}
	const [uri, paramString] = url.split("?")
	result.url = uri

	if (paramString) {
		let params = paramString.split("&")
		for (let param of params) {
			let split = param.split("=")
			let key = split.shift()
			result.params[key] = split.join("=")
		}
	}

	return result
}
